var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowWhiteBackgroundIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_272",
    x: 0,
    y: 0,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0032c5",
    floodOpacity: 0.133
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162008",
    "data-name": "Group 162008",
    transform: "translate(-360 -546)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 360, 546)",
    filter: "url(#Ellipse_272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_272-2",
    "data-name": "Ellipse 272",
    transform: "translate(9 6)",
    fill: "#fff",
    stroke: "rgba(191,196,211,0.13)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "arrow_right",
    "data-name": "arrow right",
    transform: "translate(373 556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83788",
    "data-name": "Path 83788",
    d: "M10,24h9.917",
    transform: "translate(-6.458 -15.5)",
    fill: "none",
    stroke: "#92979b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83789",
    "data-name": "Path 83789",
    d: "M24,10l4.958,4.958L24,19.917",
    transform: "translate(-15.5 -6.458)",
    fill: "none",
    stroke: "#92979b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83790",
    "data-name": "Path 83790",
    d: "M0,0H17V17H0Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWhiteBackgroundIcon);
export default __webpack_public_path__ + "static/media/right-arrow-white-background-icon.f04420504040ec8a2b81eb0d2bc3f6c9.svg";
export { ForwardRef as ReactComponent };